import React from 'react'
import styles from './StandardLayout.scss'
import {GlobalNav} from 'common/GlobalNav'
import {GlobalFooter} from 'common/GlobalFooter'
import {base} from 'lib/styleguide/base.scss'
import cx from 'classnames'

export class StandardLayout extends React.PureComponent {
  render () {
    const {children, greyBg, overrideNav, className} = this.props

    return (
      <div className={cx(styles.StandardLayout, base, greyBg && styles.greyBg, className)}>
        {overrideNav || <GlobalNav />}
        <div className={styles.content}>
          {children}
        </div>
        <GlobalFooter />
      </div>
    )
  }
}
